"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPOND_SEARCH_PLACES = exports.RESPOND_AUTOCOMPLETE_PLACES = exports.REQUEST_SEARCH_PLACES = exports.REQUEST_AUTOCOMPLETE_PLACES = void 0;
var _messageModel = require("../../messageModel");
// Must match backend WidgetsMsgCategories.WIDGETS_GEOCODING (OFFSET = 7300)
var WIDGETS_GEOCODING = 7300;
var REQUEST_SEARCH_PLACES = exports.REQUEST_SEARCH_PLACES = new _messageModel.RequestMessageDefinition(WIDGETS_GEOCODING, 0);
var REQUEST_AUTOCOMPLETE_PLACES = exports.REQUEST_AUTOCOMPLETE_PLACES = new _messageModel.RequestMessageDefinition(WIDGETS_GEOCODING, 1);
var RESPOND_SEARCH_PLACES = exports.RESPOND_SEARCH_PLACES = new _messageModel.RespondMessageDefinition(WIDGETS_GEOCODING, 0);
var RESPOND_AUTOCOMPLETE_PLACES = exports.RESPOND_AUTOCOMPLETE_PLACES = new _messageModel.RespondMessageDefinition(WIDGETS_GEOCODING, 1);